import {
  COURIER_LICENSE_TIERS,
  getCourierLicenseLevel,
  type CourierLicenseTier,
} from '../../../../domain';
import {
  formatLicenseRequirement,
  getCourierLicenseTierLabel,
} from '../courierLicenseLabels';

export const LEVEL_CARDS_PER_PAGE = 5;

/** Figma l_1 … l_5 screen Y positions. */
export const LEVEL_CARD_POSITIONS = [
  497.75,
  703.6015625,
  909.453125,
  1115.3046875,
  1321.15625,
] as const;

export const LEVEL_CARDS_PAGE_STEP =
  LEVEL_CARD_POSITIONS[1] - LEVEL_CARD_POSITIONS[0];

export const MAX_LEVEL_PAGE = Math.max(
  0,
  Math.ceil(COURIER_LICENSE_TIERS.length / LEVEL_CARDS_PER_PAGE) - 1,
);

export type LevelCardViewModel = {
  key: number;
  top: number;
  title: string;
  description: string;
  achieved: boolean;
  isCurrent: boolean;
};

export function buildLevelCardsForPage(
  page: number,
  successfulDeliveries: number,
  averageRating: number,
): LevelCardViewModel[] {
  const currentLevel = getCourierLicenseLevel(successfulDeliveries, averageRating);
  const start = page * LEVEL_CARDS_PER_PAGE;
  const tiers = COURIER_LICENSE_TIERS.slice(start, start + LEVEL_CARDS_PER_PAGE);

  return tiers.map((tier: CourierLicenseTier, index) => ({
    key: tier.level,
    top: LEVEL_CARD_POSITIONS[index] ?? LEVEL_CARD_POSITIONS[0],
    title: `${tier.level}. ${getCourierLicenseTierLabel(tier.nameKey)}`,
    description: formatLicenseRequirement(
      tier.minAverageRating,
      tier.minSuccessfulDeliveries,
    ),
    achieved: currentLevel >= tier.level,
    isCurrent: tier.level === currentLevel && currentLevel > 0,
  }));
}
